import config from "../config/env";
import StackdriverErrorReporter from "stackdriver-errors-js";
const { version } = require("../../package.json");

export function graphQLError() {
  alert(
    "An error has occurred.",
    undefined,
    [
      {
        text: "Logout",
        onPress: async () => {}
      }
    ],
    {
      cancelable: false
    }
  );
}

export async function reportError(error, stack) {
  if (!stack) {
    stack = new Error().stack;
  }
  if (process.env.NODE_ENV !== "production") {
    console.log(`ERROR REPORTED: ${error} | stack: \n${stack}`);
  } else {
    const errorHandler = new StackdriverErrorReporter();
    errorHandler.start({
      key: config.env.REACT_APP_GCP_ERROR_REPORTING_API_KEY,
      projectId: config.env.REACT_APP_GCP_PROJECT_ID,
      service: "web"
    });
    const userId = parseInt(sessionStorage.getItem("userId")) || "unknown";
    errorHandler.report(`userId: ${userId} | version: ${version} | error: ${error} | stack: \n${stack}`);
  }
}
